import React from 'react';
import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  Tooltip,
} from '@mui/material';
import { StyledIconButton } from './IconButton.style';

export interface IconButtonProps extends MuiIconButtonProps {
  /**
   * The tooltip text to display
   */
  tooltip?: string;
  /**
   * The variant of the icon button
   */
  variant?: 'contained' | 'outlined' | 'text';
  /**
   * Whether the button should pulse
   */
  pulse?: boolean;
}

export const IconButton: React.FC<IconButtonProps> = ({
  children,
  tooltip,
  variant = 'text',
  pulse = false,
  ...props
}) => {
  const button = (
    <StyledIconButton
      variant={variant}
      pulse={pulse}
      {...props}
    >
      {children}
    </StyledIconButton>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
}; 